/* eslint-disable */
import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';

import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';

import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.css';

import '@/css/desktop/tooltip.scss';

import '@/js/desktop/components/search/useFilters/styles/useFilters.css';
import '@/js/desktop/components/search/useFilters/styles/useFiltersBnr.scss';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';

import firstPaymentDefinitionService from '@/js/common/Domain/Service/firstPaymentDefinition';

import { createApp } from '@vue/composition-api';
import PartialPaymentBannerForProductCard
    from '@ve/components/partialPayment/partialPaymentBannerForProductCard/desktop/PartialPaymentBannerForProductCard.vue';
import CashbackPartialPaymentBannerForProductCard
    from '@ve/components/partialPayment/cashbackPartialPaymentBannerForProductCard/desktop/CashbackPartialPaymentBannerForProductCard.vue';
import checkProductCashbackAvailable from '@/js/common/Domain/Service/checkProductCashbackAvailable';
import SearchPageHotelCardAbstract from '@/js/desktop/View/Abstract/SearchPageHotelCardAbstract';

import template from './searchPageHotelOffers/hotelTemplate.html';
import '@/css/common/components/warranted-icon.scss';

export default SearchPageHotelCardAbstract.extend({
    el: '<div class="serpHotelCard"></div>',
    data: null,
    template,
    events: {
        'click .goToHotel': 'goToHotel',
        'click .js-images-carousel-control-prev': 'sliderArrowClick',
        'click .js-images-carousel-control-next': 'sliderArrowClick',
        'mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange)': 'hotelClick',
        'click .serpHotelCard__container a:not(.goto-ua-page, .notChange)': 'callYMGoals',
    },
    trackingHotelClick() {
        trackingService.trackSerpHotelPosition({
            hotels: this.collectionView.collection,
            selectedHotel: this.model,
            sortStrategy: this.collectionView.model.get('sortStrategy'),
        });

        mindBoxService.trackViewSerpClick('serp_hotel', {
            searhPageModel: this.model,
            collectionViewModel: this.collectionView.model,
        });
    },
    hotelClick(e) {
        this.trackingHotelClick();
        this.hrefUrl(e);
    },
    render() {
        let template;
        const self = this;
        const data = this.model.toJSON({ computed: true });
        const hotelIndex = self.collectionView.collection.indexOf(self.model);

        if (self.collectionView) {
            template = this.selectTemplate();
        }

        data.originalHotelObject = this.model;

        data.hotelIndex = hotelIndex;

        if (this.hotelMapView) {
            this.hotelMapView.reRender({
                data,
                $el: this.$el,
                parentModel: this.model,
                collectionView: this.collectionView,
            });
        } else {
            this.$el.html(template(data));
        }

        setTimeout(() => {
            self.applyBindings();
        }, 0);

        this.data = data;

        this.initCarousel();
        this.renderPhotos();
        this.initSubViews();
        this.initVueComponents();

        this.showBottomBanner();
    },

    showBottomBanner() {
        const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();

        const hasTourCashbackAvailable = checkProductCashbackAvailable(this.model.get('hotelOffers'));

        const isCashbackAvailable = window?.appConfig?.cashbackAvailable
            && hasTourCashbackAvailable;

        if (isCashbackAvailable) {
            if (isVisiblePartialPayment) {
                this.initCashbackPartialPaymentBanner();
                return;
            }
            this.initCashbackBanner('hotelOffer');
            return;
        }

        if (isVisiblePartialPayment) {
            this.initPartialPaymentBanner();
        }
    },

    getPartialPaymentData() {
        const hotelOffers = this.model.get('hotelOffers');
        const hotelOffer = hotelOffers?.at(0);
        const firstPaymentDefinitions = firstPaymentDefinitionService.getData();

        const isVisible = !!hotelOffer.get('firstPaymentDefinition')?.id && firstPaymentDefinitions.length > 0;
        const countryName = this.model.get('country').get('name');

        return {
            isVisible,
            countryName,
            hotelOffers,
        };
    },

    initPartialPaymentBanner() {
        const { countryName, hotelOffers } = this.getPartialPaymentData();
        this.$el.addClass('partialPayment');

        this.partialPaymentBanner = createApp(PartialPaymentBannerForProductCard, {
            countryName,
            products: hotelOffers.toJSON(),
            productType: 'hotelOffer',
        }).mount(this.$el.find('.partialPayment__banner').get(0));
    },

    initCashbackPartialPaymentBanner() {
        const { countryName, hotelOffers } = this.getPartialPaymentData();
        this.$el.addClass('cashbackPartialPayment');

        this.cashbackPartialPaymentBanner = createApp(CashbackPartialPaymentBannerForProductCard, {
            countryName,
            products: hotelOffers.toJSON(),
            productType: 'hotelOffer',
        }).mount(this.$el.find('.cashbackPartialPayment__banner').get(0));
    },

    initSubViews() {
        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    },

    initSubscribes() {
        this.listenTo(this.model, 'change:minPrice', $.proxy(this.reRender, this));
        this.listenTo(this.model, 'change:hotelOffers', $.proxy(this.reRender, this));
    },
    initialize(options) {
        this.collectionView = options.collectionView;
        this.hotelMapView = options.hotelMapView;

        this.render();
        this.initSubscribes();
    },
    hrefUrl(event) {
        const hotelOffer = this.model.get('hotelOffers').at(0);
        const identity = $(event.currentTarget).data('identity') || hotelOffer.get('id');
        const urlParams = toRouterHotelHydrator({
            tourCriteria: hotelOffer.get('tourCriteria'),
            similar: !!this.model.get('similar'),
            productType: 'hotelOffer',
            identity,
            minPrice: this.model.get('minPrice'),
            operatorId: hotelOffer.get('operator').id,
            sid: searchSessionService.getSearchId(),
            suuid: trackingService.getSearchUuid(),
        });
        const hotelUrl = this.model.get('url');
        const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
        const $target = $(event.currentTarget);

        if (typeof identity !== 'undefined') {
            if (event.which === 2) {
                gaAsync(() => {
                    ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', { nonInteraction: 1 });
                });
            }
        } else if (event.which === 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
            gaAsync(() => {
                ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', { nonInteraction: 1 });
            });
        }
        if ($target.hasClass('distance')) {
            urlParams.toMap = true;
        }
        $(event.currentTarget).attr('href', `${hotelUrl}#?${$.param(urlParams)}`);
        $(event.currentTarget).attr('target', target);
        ls.set('isAbsent', false);
    },
    buildUrlParams() {
        const hotelOffer = this.model.get('hotelOffers').at(0);
        const identity = $(event.currentTarget).data('identity') || hotelOffer.get('id');
        const tourCriteria = hotelOffer.get('tourCriteria');
        return toRouterHotelHydrator({
            tourCriteria,
            productType: 'hotelOffer',
            identity,
            minPrice: this.model.get('minPrice'),
            operatorId: hotelOffer.get('operator').id,
            sid: searchSessionService.getSearchId(),
            suuid: trackingService.getSearchUuid(),
        });
    },
});
